/**
 * Storage Interface
 * Defines the contract that all storage implementations must follow
 */
class IStorage {
    /**
     * Get a value from storage
     * @param {string} key - The key to retrieve
     * @returns {Promise<any>} The stored value or null if not found
     */
    async get(key) {
        throw new Error('Method get() must be implemented');
    }

    /**
     * Set a value in storage
     * @param {string} key - The key to store
     * @param {any} value - The value to store
     * @returns {Promise<void>}
     */
    async set(key, value) {
        throw new Error('Method set() must be implemented');
    }

    /**
     * Remove a value from storage
     * @param {string} key - The key to remove
     * @returns {Promise<void>}
     */
    async remove(key) {
        throw new Error('Method remove() must be implemented');
    }

    /**
     * Clear all values from storage
     * @returns {Promise<void>}
     */
    async clear() {
        throw new Error('Method clear() must be implemented');
    }

    /**
     * Get all keys from storage
     * @returns {Promise<string[]>} Array of all keys
     */
    async keys() {
        throw new Error('Method keys() must be implemented');
    }

    /**
     * Check if a key exists in storage
     * @param {string} key - The key to check
     * @returns {Promise<boolean>}
     */
    async has(key) {
        throw new Error('Method has() must be implemented');
    }

    /**
     * Get the number of items in storage
     * @returns {Promise<number>}
     */
    async length() {
        throw new Error('Method length() must be implemented');
    }
}

export default IStorage;
